/*
 * Babylon Parfums — complimentary gift opt-in
 *
 * The "Add to cart" button stays disabled until the customer ticks the
 * acknowledgement box. On click it adds the gift variant, then re-renders
 * the cart drawer (or reloads the cart page) so the new line item shows.
 */
if (!customElements.get('bp-gift-offer')) {
  customElements.define(
    'bp-gift-offer',
    class BPGiftOffer extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('[data-bp-gift-ack]');
        this.button = this.querySelector('[data-bp-gift-add]');
        this.errorEl = this.querySelector('[data-bp-gift-error]');
        this.variantId = this.dataset.variantId;

        if (!this.checkbox || !this.button || !this.variantId) return;

        this.checkbox.addEventListener('change', this.onAckChange.bind(this));
        this.button.addEventListener('click', this.onAdd.bind(this));
      }

      onAckChange() {
        this.button.disabled = !this.checkbox.checked;
        this.hideError();
      }

      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onAdd() {
        if (!this.checkbox.checked || this.button.classList.contains('is-loading')) return;

        this.hideError();
        this.setLoading(true);

        const body = {
          items: [{ id: Number(this.variantId), quantity: 1 }],
        };

        const cart = this.cart;
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            // Shopify returns a `status` field only when the add failed.
            if (data.status) {
              this.showError(data.description || data.message);
              return;
            }

            // On the cart page there is no drawer to re-render.
            if (!cart) {
              window.location.reload();
              return;
            }

            cart.renderContents(data);
          })
          .catch(() => {
            this.showError('Something went wrong adding your gift. Please try again.');
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        this.button.classList.toggle('is-loading', isLoading);
        this.button.disabled = isLoading || !this.checkbox.checked;
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }
  );
}
